import React, { useEffect, useState, Suspense, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpIcon } from 'lucide-react';
import { UrgencyBarSection } from './components/UrgencyBarSection';
import { HeroSection } from './components/HeroSection';
import { SocialProofPopup } from './components/SocialProofPopup';
// Lazy load below-the-fold components
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const ProductSection = lazy(() => import('./components/ProductSection').then(m => ({
  default: m.ProductSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTASection = lazy(() => import('./components/FinalCTASection').then(m => ({
  default: m.FinalCTASection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
export function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <main className="bg-primary min-h-screen text-white font-sans selection:bg-accent-teal selection:text-white" data-id="element-0">
      <UrgencyBarSection data-id="element-1" />
      <HeroSection data-id="element-2" />

      <Suspense fallback={<div className="h-32 bg-primary" data-id="element-4" />} data-id="element-3">
        <PainSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <ProductSection data-id="element-7" />

        <BonusSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <FinalCTASection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <FooterSection data-id="element-14" />
      </Suspense>

      <SocialProofPopup data-id="element-15" />

      <AnimatePresence data-id="element-16">
        {showScrollTop && <motion.button initial={{
        opacity: 0,
        scale: 0.5
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.5
      }} onClick={scrollToTop} className="fixed bottom-6 right-6 z-40 bg-accent-gold text-primary p-3 rounded-full shadow-lg hover:scale-110 transition-transform" aria-label="Volver arriba" data-id="element-17">
            <ArrowUpIcon className="w-6 h-6" data-id="element-18" />
          </motion.button>}
      </AnimatePresence>
    </main>;
}